import { generateCustomEdge } from 'src/newComponents/edges/config'
import { generateJavaPluginActionNodeConfig } from 'src/newComponents/nodes/customActionNode/config'
import { generateInputNodeConfig } from 'src/newComponents/nodes/inputNode/config'
import { generateLLMNodeConfig } from 'src/newComponents/nodes/llmNode/config'
import { generateMessageActionNodeConfig } from 'src/newComponents/nodes/messageNode/config'
import { generateOutputNodeConfig } from 'src/newComponents/nodes/outputNode/config'
import type { CustomEdgeType } from 'src/newComponents/edges/customEdge'
import type { CustomNodeType } from 'src/newComponents/nodes/types'

export function generateId() {
  let id = 0
  return {
    getNow: () => id,
    getId: () => {
      id += 1
      return id
    },
    setId: (max: number) => {
      id = max
    },
  }
}

export const IDControler = generateId()
export const generateNodes = {
  input: generateInputNodeConfig,
  output: generateOutputNodeConfig,
  LLMAction: generateLLMNodeConfig,
  JavaPluginAction: generateJavaPluginActionNodeConfig,
  MessageAction: generateMessageActionNodeConfig,
}

export function generateInitialNodesAndEdges() {
  const input = generateNodes.input()
  const output = generateNodes.output()
  output.position = {
    x: 0,
    y: 200,
  }
  return {
    nodes: [input, output],
    edges: [
      generateEdge(
        String(IDControler.getId()),
        '',
        input.id,
        output.id,
        'bottom',
        'top',
      ),
    ],
  }
}

export function generateEdge(id: string, edgeName: string, source: string, target: string, sourceHandle: string | null, targetHandle: string | null): CustomEdgeType {
  const edge: CustomEdgeType = generateCustomEdge(
    id,
    edgeName,
    source,
    target,
    sourceHandle,
    targetHandle,
  )
  return edge
}

export function getNodePosition(nodes: CustomNodeType[], sourcePosition: { x?: number, y?: number } = { x: 0, y: 0 }, space: { x?: number, y?: number }): { x: number, y: number } {
  const position = {
    x: (sourcePosition.x || 0) + (space.x || 0),
    y: (sourcePosition.y || 0) + (space.y || 0),
  }
  const currentNode = nodes.find(
    n => n.position.x === position.x && n.position.y === position.y,
  )
  if (currentNode) {
    return getNodePosition(nodes, position, space)
  }
  return position
}
